import { graphql } from "react-relay";

export const fragments = {
  org: graphql`
    fragment ProfileCollaborators_org on Org
    @argumentDefinitions(
      calendarId: { type: "String!" }
      timeZone: { type: "String!" }
      rangeMin: { type: "DayTimeSlotInput!" }
      rangeMax: { type: "DayTimeSlotInput!" }
    ) {
      id
      collaboratorStatsErrorable(
        calendarId: $calendarId
        timeZone: $timeZone
        rangeMin: $rangeMin
        rangeMax: $rangeMax
      ) {
        __typename

        ... on GraphEntityError {
          statusCode
        }

        ... on CollaboratorStats {
          calendarId
          topCollaborators {
            calendarId
            sharedMinutes
          }
        }
      }
    }
  `,
  orgRefetch: graphql`
    fragment ProfileCollaborators_orgRefetch on Org
    @argumentDefinitions(calendarIds: { type: "[String]!", defaultValue: [] }) {
      id
      personsByCalendarIdsErrorable(calendarIds: $calendarIds) {
        __typename
        ... on PersonList {
          list {
            id
            primaryEmail
            profile {
              givenName
              familyName
            }
          }
        }
        ... on GraphEntityError {
          message
        }
      }
    }
  `,
};

export const refetchQuery = graphql`
  query ProfileCollaboratorsQuery($orgRelayId: ID!, $calendarIds: [String]!) {
    orgRefetch: node(id: $orgRelayId) {
      ... on Org {
        ...ProfileCollaborators_orgRefetch @arguments(calendarIds: $calendarIds)
      }
    }
  }
`;
